import React from "react";
import { MdAttachFile } from "react-icons/md";

/**
 * Actions column: the attachments button (paperclip and count, or "+" to add
 * one; both open the attachments pop-up, as before) and the actions menu.
 */
const ActionsCell = ({ row, onOpenAttachments, menu }) => {
  const count = row?.attachments?.length ?? 0;
  const label = count
    ? `${count} attachment${count === 1 ? "" : "s"} on #${row?.id}`
    : `Add attachment to #${row?.id}`;

  return (
    <div className="flex w-full items-center justify-end gap-[6px]">
      <button
        type="button"
        onClick={() => onOpenAttachments(row?.id)}
        aria-label={label}
        title={count ? label : "Add attachment"}
        className={`flex h-[26px] shrink-0 items-center gap-[1px] rounded-md border-0 bg-transparent px-[4px] transition-colors hover:bg-ui-row-hover hover:text-brand ${
          count ? "text-ui-text" : "text-ui-text-subtle"
        }`}
      >
        <MdAttachFile className="h-[14px] w-[14px]" />
        {count > 0 ? (
          <span className="font-semibold">{count}</span>
        ) : (
          <span aria-hidden="true" className="font-semibold">
            +
          </span>
        )}
      </button>
      {menu}
    </div>
  );
};

export default ActionsCell;
